import styled from "styled-components";
import { colors } from "../../01_config/Colors"; // adjust path if needed

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  display: ${({ googlemeetVisible }) => (googlemeetVisible ? "block" : "none")};
//   display: block;
  background: rgba(0, 0, 0, 0.45);
  z-index: 199; /* below panel, above rest */
`;

export const GuideWrapper = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  display: ${({ googlemeetVisible }) => (googlemeetVisible ? "flex" : "none")};
//   display: flex;
  flex-direction: column;
  gap: 12px;

  width: 720px;
  max-width: 88vw;
  max-height: 85vh;
  overflow: auto;

  padding: 20px;
  color: white;
  background-color: ${colors.mainDark};
  border-radius: 8px;
  z-index: 200;

  @media (max-width: 800px) {
    width: 92vw;
    max-height: 85vh;
    padding: 16px;
  }
`;

export const Title = styled.div`
  font-size: 1.3rem;
  font-weight: 600;
  margin-bottom: 4px;
`;

export const Subtitle = styled.div`
  color: yellow;
  font-size: 0.85rem;
  text-align: left;
`;

export const Steps = styled.ol`
  margin: 0;
  padding-left: 18px;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const Step = styled.li`
  line-height: 1.4;
  margin-top: 20px;
`;

export const ImagePlaceholder = styled.div`
  margin-top: 8px;
  border-radius: 6px;
  border: 1px dashed rgba(255, 255, 255, 0.35);
  border: 1px solid rgba(255, 255, 255, 0.35);
  padding: 10px 12px;
  font-size: 0.9rem;
  opacity: 0.9;

  @media (max-width: 800px) {
    font-size: 0.85rem;
  }
`;

export const Image = styled.img`
    width: 100%;
`

export const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 6px;
`;

export const CloseButton = styled.button`
  width: 140px;
  height: 35px;
  font-size: 1rem;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background-color: grey;

  @media (max-width: 800px) {
    width: calc(30px + 60vw);
    height: 5vh;
  }

  &:active {
    transform: translate(2px, 2px);
  }
`;
